import { RootState } from "../../store/reducers";

export const userSelector = (state: RootState) => state.user;
export const userTokenSelector = (state: RootState) => state.user.userToken;
export const userIdSelector = (state: RootState) => state.user.userId;
export const whoAmISelector = (state: RootState) => state.user.whoAmI;